import type { ServiceDto, ServiceForExternalSystemDto, ServiceForExternalSystemPagedRequestDto, ServiceInputDto, ServicePagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  apiName = 'Default';
  

  createByInputDto = (inputDto: ServiceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/service',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteByServiceId = (serviceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/service',
      params: { serviceId },
    },
    { apiName: this.apiName,...config });
  

  editByInputDto = (inputDto: ServiceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/service/edit',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: ServicePagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ServiceDto>>({
      method: 'GET',
      url: '/api/app/service',
      params: { name: input.name, code: input.code, serviceTypeId: input.serviceTypeId, vendorId: input.vendorId, externalSystemIds: input.externalSystemIds, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByServiceId = (serviceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceDto>({
      method: 'GET',
      url: `/api/app/service/by-id/${serviceId}`,
    },
    { apiName: this.apiName,...config });
  

  getServiceByIdForExternalSystemsByServiceId = (serviceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ServiceForExternalSystemDto>({
      method: 'GET',
      url: `/api/app/service/service-by-id-for-external-systems/${serviceId}`,
    },
    { apiName: this.apiName,...config });
  

  getServicesForExternalSystemsByInput = (input: ServiceForExternalSystemPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ServiceForExternalSystemDto>>({
      method: 'GET',
      url: '/api/app/service/services-for-external-systems',
      params: { externalSystemCode: input.externalSystemCode, serviceNameFilter: input.serviceNameFilter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
